module.exports = __webpack_public_path__ + "static/media/codesBeingGenerated.d8562782.png";